// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';

const DEFAULT_USER_TIER_URL = `usertier`;

async function get(endpoint?: string) {
    return await call('get', endpoint);
}

async function post(endpoint?: string, body?: any) {
    return await call('post', endpoint, body);
}

async function call(method: string, endpoint?: string, body?: any) {
    const url = endpoint
        ? `${DEFAULT_USER_TIER_URL}/${endpoint}`
        : DEFAULT_USER_TIER_URL;

    return await HttpService.proxiedApiCall({
        body,
        requestUrl: url,
        type: method,
    });
}

export default {
    async getUserInfo() {
        return await get();
    },

    async getAllUsers() {
        return await get('all');
    },

    async getSoldToShipTo() {
        return await get('soldtoshipto');
    },

    async getSoldToList() {
        return await get('soldtolist');
    },

    async getShipToList() {
        return await get('shiptolist');
    },

    async getOnSiteSoldToShipToList() {
        return await get('onsite/soldtoshipto');
    },

    async getRoles() {
        return await get('roles');
    },

    async getChannels() {
        return await get('channels');
    },

    async getTiers(request: any) {
        const { channel } = request && request.payload && request.payload;
        const path = channel ? `tiers/${channel}` : 'tiers';
        return await get(path);
    },

    async createUser(request: any) {
        const body = request.payload;
        return post('create', body);
    },

    async deleteUser(request: any) {
        const body = {
            deleteUserPayload: request.payload,
        };
        const response = await post('delete', body);
        return response;
    },

    async manageSoldToShipTo(request: any) {
        const body = request.payload;
        return post('managesoldtoshipto', body);
    },
};
